/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PeSignupStatus { 
    ewebextra?: PeSignupStatus.EwebextraEnum;
    patientNotifications?: PeSignupStatus.PatientNotificationsEnum;
    omi?: PeSignupStatus.OmiEnum;
}
export namespace PeSignupStatus {
    export const EwebextraEnum = {
        SignUp: 'SignUp',
        Manage: 'Manage',
        Pending: 'Pending',
        ReconcileDomain: 'ReconcileDomain'
    } as const;
    export type EwebextraEnum = typeof EwebextraEnum[keyof typeof EwebextraEnum];
    export const PatientNotificationsEnum = {
        SignUp: 'SignUp',
        Manage: 'Manage',
        Pending: 'Pending',
        ReconcileDomain: 'ReconcileDomain'
    } as const;
    export type PatientNotificationsEnum = typeof PatientNotificationsEnum[keyof typeof PatientNotificationsEnum];
    export const OmiEnum = {
        SignUp: 'SignUp',
        Manage: 'Manage',
        Pending: 'Pending',
        ReconcileDomain: 'ReconcileDomain'
    } as const;
    export type OmiEnum = typeof OmiEnum[keyof typeof OmiEnum];
}


